"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PersonaHeader_1 = require("./components/PersonaHeader");
exports.PersonaHeader = PersonaHeader_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/people/owa-people-persona-header-view/lib/lazyIndex.js
// module id = 2342
// module chunks = 46